import { render, staticRenderFns } from "./ShopDetail.vue?vue&type=template&id=4b3fc5f5&scoped=true&"
import script from "./ShopDetail.vue?vue&type=script&lang=js&"
export * from "./ShopDetail.vue?vue&type=script&lang=js&"
import style0 from "./ShopDetail.vue?vue&type=style&index=0&id=4b3fc5f5&lang=scss&scoped=true&"
import style1 from "./ShopDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3fc5f5",
  null
  
)

export default component.exports